import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

/**
 * Masked input for postal codes. Mask varies by country.
 * Use as `inputComponent` on MUI TextField's input slot.
 *
 * @param {object} props
 * @param {import("prop-types").InferProps<typeof PostalCodeMaskInputPropTypes>["country"]} props.country ISO 3166-1 alpha-2 country code.
 * @param {import("prop-types").InferProps<typeof PostalCodeMaskInputPropTypes>["name"]} props.name Field name returned in the synthetic event.
 * @param {React.Ref<HTMLInputElement>} [props.ref]
 * @param {((event: { target: { name: string | undefined, value: string } }) => void) | null} [props.onChange]
 */
export default function PostalCodeMaskInput({ onChange = null, country, name, ref, ...other }) {
  if (country === 'CA') {
    return (
      <IMaskInput
        name={name}
        {...other}
        overwrite
        mask="a0a 0a0"
        placeholder="A1A 1A1"
        prepareChar={char => char.toUpperCase()}
        inputRef={ref}
        onAccept={value => onChange?.({ target: { name, value } })}
      />
    );
  }

  if (country === 'US') {
    return (
      <IMaskInput
        name={name}
        {...other}
        overwrite
        inputMode="numeric"
        mask="00000"
        placeholder="90210"
        inputRef={ref}
        onAccept={value => onChange?.({ target: { name, value } })}
      />
    );
  }

  // Other countries: plain input, no mask
  return <input name={name} {...other} ref={ref} />;
}

const PostalCodeMaskInputPropTypes = {
  country: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};
PostalCodeMaskInput.propTypes = PostalCodeMaskInputPropTypes;
